import React, { useState } from 'react';

import Item from 'schema/item';

interface ItemContextProviderProps {
  children?: React.ReactNode;
}

const ItemContext = React.createContext<{
  item: Item | null;
  setItem: React.Dispatch<React.SetStateAction<Item | null>> | null;
}>({ item: null, setItem: null });

const ItemContextProvider: React.FC<ItemContextProviderProps> = ({
  children,
}) => {
  const [item, setItem] = useState<Item | null>(null);

  return (
    <ItemContext.Provider value={{ item, setItem }}>
      {children}
    </ItemContext.Provider>
  );
};

export default ItemContextProvider;
export { ItemContext };
